module.exports = __webpack_public_path__ + "assets/img/1-1.b20f5131.jpg";